(function () {
  function initSection(root) {
    if (!root || root.dataset.nqInit === 'true') return;
    root.dataset.nqInit = 'true';

    var list = root.querySelector('[data-nq-list]');
    var showMoreBtn = root.querySelector('[data-nq-showmore]');
    var lightbox = root.querySelector('[data-nq-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-nq-lightbox-img]') : null;
    var lightboxClose = root.querySelector('[data-nq-lightbox-close]');

    /* ---- Show more reviews ---- */
    if (list && showMoreBtn) {
      var items = Array.from(list.querySelectorAll('[data-nq-item]'));
      var initial = parseInt(list.dataset.initial, 10) || 4;

      if (items.length <= initial) {
        showMoreBtn.hidden = true;
      } else {
        items.forEach(function (item, i) {
          if (i >= initial) item.classList.add('nq-is-hidden');
        });

        showMoreBtn.addEventListener('click', function () {
          items.forEach(function (item) {
            item.classList.remove('nq-is-hidden');
          });
          showMoreBtn.hidden = true;
        });
      }
    }

    /* ---- Photo lightbox ---- */
    if (lightbox && lightboxImg) {
      root.querySelectorAll('[data-nq-photo-trigger]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var full = btn.getAttribute('data-full');
          if (!full) return;
          lightboxImg.setAttribute('src', full);
          lightbox.hidden = false;
        });
      });

      function closeLightbox() {
        lightbox.hidden = true;
        lightboxImg.setAttribute('src', '');
      }

      if (lightboxClose) {
        lightboxClose.addEventListener('click', closeLightbox);
      }
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.nq-reviews').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when merchant edits blocks/settings in the Shopify theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.nq-reviews');
    if (root) {
      root.dataset.nqInit = 'false';
      initSection(root);
    }
  });
})();
